

<div class="tenant-dashboard container-fluid bg-light py-5">
  <div class="row justify-content-center g-4">

    <!-- LEFT COLUMN: Tenant Overview & Links -->
    <div class="col-lg-4 col-md-5">
      <div class="card shadow-sm border-0 rounded-4">
        <div *ngIf="user$ | async as user;" class="card-body p-4">
          <h5 class="fw-semibold text-secondary mb-3">Welcome, {{ user.firstName || 'Tenant' }}</h5>
          <div class="mb-4">
            <p class="mb-1"><strong>Name:</strong> {{ user.firstName || 'Tenant' }} {{ user.lastName  || '' }}</p>
            <p class="mb-1"><strong>Email:</strong> {{ user.email }}</p>
            <div *ngIf="rental$ | async as rental;">
              <p class="mb-1"><strong>Monthly Rent:</strong> {{ rental.price | currency:'USD':'symbol':'1.2-2' }}</p>
              <p class="text-muted small">Tenant of {{rental.address || 'N/A'}}</p>
            </div>
          </div>

          <hr />

          <h6 class="fw-semibold text-secondary mb-3">Quick Actions</h6>
          <div class="d-grid gap-2">
            <button class="btn btn-gradient" (click)="goToPay()">Make a Payment</button>
            <button class="btn btn-primary" (click)="goToSubscribe()">Start a Monthly Subscription</button>
            <button class="btn btn-outline-secondary" (click)="goToPayments()">Payments</button>
            <button class="btn btn-outline-secondary" (click)="goToDocuments()">Documents</button>
            <button class="btn btn-outline-primary" (click)="goToProfile()">Edit Profile</button>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT COLUMN: documents + Payments -->
    <div class="col-lg-7 col-md-7">
      <!-- SUBSCRIPTION CARD -->
<div class="card shadow-sm border-0 rounded-4 mb-4 "*ngIf="subscription$ | async as subs" >
  <div class="card-body p-4">
    <h5 class="fw-semibold text-secondary mb-3">Your Subscription</h5>

    <ng-container *ngIf="subs.length > 0; else noSub">
      <div *ngFor="let sub of subs" class="p-3 rounded-3 border bg-white mb-3">

        <p class="mb-1">
          <strong>Plan:</strong> {{ sub.plan_name || 'Subscription' }}
        </p>

        <p class="mb-1">
          <strong>Status:</strong>
          <span class="badge"
            [ngClass]="{
              'bg-success': sub.status === 'active',
              'bg-warning text-dark': sub.status === 'past_due',
              'bg-danger': sub.status === 'canceled'
            }">
            {{ sub.status | titlecase }}
          </span>
        </p>

        <p class="mb-1">
          <strong>Billing Amount:</strong>
           {{ sub.unitAmount / 100 | currency:'USD':'symbol':'1.2-2'  }} / month
        </p>

        <p class="mb-1" *ngIf="sub.nextPaymentDue">
          <strong>Next Billing Date:</strong> {{ sub.nextPaymentDue | date:'MMM d, y, h:mm a'}}
        </p>

        <p class="mb-1" *ngIf="sub.cancel_at_period_end">
          <strong>Cancellation:</strong> Active until end of period
        </p>

        <div class="d-grid mt-3">
          <button class="btn btn-outline-danger" (click)="cancelSubscription(sub.id)">
            Cancel Subscription
          </button>
        </div>

      </div>
    </ng-container>

    <ng-template #noSub>
      <p class="text-muted fst-italic">No active subscription found.</p>
    </ng-template>
  </div>

       </div>
<div class="payments-container">
  <div class="card shadow-sm border-0 rounded-4 mb-4">
    <div class="card-body p-3">
      <h5 class="fw-semibold text-secondary mb-3">Recent Payments</h5>

      <ng-template #loadingPayments>
        <p class="text-muted">Loading payments...</p>
      </ng-template>

      <ng-template #noPayments>
        <p class="text-muted fst-italic">No payments found.</p>
      </ng-template>

      <div *ngIf="payments$ | async as payments; else loadingPayments">
        <div *ngIf="payments.length > 0; else noPayments">

          <div
            *ngFor="let payment of payments; trackBy: trackPayment"
            class="payment-row"
          >
            <!-- LEFT -->
            <div class="payment-left">
              <div class="amount">
                {{ payment.amountinCents | currency:'USD':'symbol':'1.2-2' }}
              </div>
              <div class="date">
                {{ payment.createdAtFormatted }}
              </div>
            </div>

            <!-- RIGHT GROUP -->
            <div class="payment-right">
              <div class="meta">
                <span
                  class="badge"
                  [ngClass]="
                    payment.status === 'succeeded' ? 'bg-success' :
                    payment.status === 'pending' ? 'bg-warning text-dark' :
                    'bg-danger'
                  "
                >
                  {{ payment.status | titlecase }}
                </span>

                <span class="method">
                  {{ payment.paymentMethod === 'us_bank_account'
                    ? 'Bank'
                    : payment.paymentMethod | titlecase }}
                </span>
              </div>

              <button
                *ngIf="payment.brandedReceiptUrl"
                class="btn btn-outline-primary btn-sm download-btn"
                (click)="downloadReceipt(payment.brandedReceiptUrl)"
                aria-label="Download receipt"
              >
                <i class="bi bi-download"></i>
              </button>

              <span
                *ngIf="!payment.brandedReceiptUrl"
                class="pending-text"
              >
                Pending
              </span>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>







      <!-- documents CARD -->
      <div class="card shadow-sm border-0 rounded-4 mb-4">
        <div class="card-body p-4">
          <h5 class="fw-semibold text-secondary mb-3">Your Documents</h5>

          <ng-template #loadingdocuments>
            <p class="text-muted">Loading documents...</p>
          </ng-template>

          <div *ngIf="documents$ | async as documents; else loadingdocuments">
            <div *ngIf="documents.length > 0; else nodocuments">
              <div *ngFor="let document of documents; trackBy: trackDocument" class="document-card p-3 mb-3 rounded-3 border bg-white-subtle">
                <p class="mb-1"><strong>Document:</strong> {{ document.signedDate }}</p>
              </div>
            </div>
            <ng-template #nodocuments>
              <p class="text-muted fst-italic">No documents found.</p>
            </ng-template>
          </div>

        </div>
      </div>


    </div>
  </div>
</div>
